/**
 * @module FE-CU42_緊急連絡先設定画面
 */
import AddContactModal from './components/modals/AddContactModal.vue';
import DeleteConfirmModal from './components/modals/DeleteConfirmModal.vue';
import EditContactModal from './components/modals/EditContactModal.vue';
import {
  firstNameClass,
  firstNameKanaClass,
  firstPhoneNumberClass,
  firstRelationshipClass,
} from './computed';
import Draggable from 'vuedraggable';
import CONSTANTS from '../../../constants';

export default {
  name: 'EmergencyContactPage',
  components: {
    AddContactModal,
    DeleteConfirmModal,
    EditContactModal,
    Draggable,
  },
  data(vm) {
    return {
      valid: true,
      dialog: false,
      result: [],
      // 画面と双方向バインディングする配列
      contacts: [],
      // 並び替え完了時にDBに送信する配列
      contactsCopy: [],
      error: {
        firstContact: {
          hasNameError: false,
          hasNameKanaError: false,
          hasRelationshipError: false,
          hasPhoneNumberError: false,
        },
      },
      rules: {
        name: [
          (value) =>
            !!value || vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU42緊急連絡先設定画面.E0001'),
          //  "氏名は必ず入力してください。"
        ],
        nameKana: [
          (value) =>
            !!value || vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU42緊急連絡先設定画面.E0003'),
          // "氏名(カナ)は必ず入力してください。",
          (value) =>
            /^[ァ-ヶー]+$/.test(value) ||
            vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU42緊急連絡先設定画面.E0005'),
          // "氏名(カナ)は全角カタカナで入力してください。",
        ],
        relationship: [
          (value) =>
            !!value || vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU42緊急連絡先設定画面.E0006'),
          // "関係は必ず入力してください。"
        ],
        phoneNumber: [
          (value) =>
            !!value || vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU42緊急連絡先設定画面.E0008'),
          // "電話番号は必ず入力してください。",
          (value) =>
            /^[0-9-]+$/.test(value) ||
            vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU42緊急連絡先設定画面.E0010'),
          // "電話番号は半角数字と「-(ハイフン)」で入力してください。",
        ],
      },
      appendAlertClass(hasError) {
        return { alert: hasError };
      },
      sortFlag: false,
      modified: '',
      width: 0,
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    editContactModalIndex() {
      return this.$mq === 'pc' ? 0 : 1;
    },
    firstNameClass,
    firstNameKanaClass,
    firstRelationshipClass,
    firstPhoneNumberClass,
    isDisabled() {
      if (!this.sortFlag) {
        if (this.contacts.length < CONSTANTS.REGISTRATION_LIMIT.EMERGENCY_CONTACT) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    currentDisplayType() {
      return this.$store.state.currentDisplayType;
    },
  },
  async mounted() {
    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    // 遷移元からtabIndexのパラメータを受け取った場合にタブを切り替える
    if (this.$route.params.tabIndex) {
      this.currentTab = this.$route.params.tabIndex;
    }

    this.width =
      this.$mq === 'pc' ? CONSTANTS.LIST_PANEL_LABEL_WIDTH.PC : CONSTANTS.LIST_PANEL_LABEL_WIDTH.SP;
    this.$watch('$mq', function () {
      this.changeItemLabelWidth(
        this.$mq === 'pc'
          ? CONSTANTS.LIST_PANEL_LABEL_WIDTH.PC
          : CONSTANTS.LIST_PANEL_LABEL_WIDTH.SP
      );
    });

    let param = '';
    let queries = {
      token: sessionStorage.getItem('token'),
      terminalInfo: localStorage.getItem('terminalInfo')
        ? localStorage.getItem('terminalInfo')
        : '',
    };

    //初期通信が遅いので、通信前に表示
    this.isShowPage = true;

    let method = 'post';
    if (this.$store.state.currentDisplayType === CONSTANTS.DISPLAY_TYPE.HOME_SECURITY) {
      // 対象地区
      param = '/api/emergencyContact/getContactInfoDisplayDistrict';
      queries.customerNumber = this.$store.state.customerNumber;
      queries.districtSplitNumber = this.$store.state.districtSplitNumber;
      await this.APP_CU4201(param, queries, method);
    } else {
      // カメラ
      param = '/api/emergencyContact/getContactInfoCamera';
      queries.deviceID = this.$store.state.deviceID;
      await this.APP_CU4202(param, queries, method);
    }
  },
  /** @type {Methods} */
  methods: {
    /**
     * 緊急連絡先情報(表示地区)取得API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストパラメータ
     * @param {*} method メソッドパラメータ
     * @returns apiData レスポンス
     */
    APP_CU4201: async function (param, queries, method) {
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          () => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     displayDistrictInfo: {
            //       usagePlan: 0,
            //       customerNumber: "51-1234567",
            //       securityDestinationName: "警備先1",
            //       districtSplitNumber: "0001",
            //       districtSplitName: "地区名1",
            //       displayDistrictNickname: "自宅",
            //     },
            //     emergencyContactList: [
            //       {
            //         emergencyContactName: "山田太郎",
            //         emergencyContactKanaName: "ヤマダタロウ",
            //         emergencyContactRelationship: "本人",
            //         emergencyContactPhoneNumber: "050-1234-1231",
            //       },
            //       {
            //         emergencyContactName: "山田田中",
            //         emergencyContactKanaName: "ヤマダタナカ",
            //         emergencyContactRelationship: "配偶者",
            //         emergencyContactPhoneNumber: "050-1192-5678",
            //       },
            //       {
            //         emergencyContactName: "山田花子",
            //         emergencyContactKanaName: "ヤマダハナコ",
            //         emergencyContactRelationship: "祖母",
            //         emergencyContactPhoneNumber: "050-1234-5678",
            //       },
            //       {
            //         emergencyContactName: null,
            //         emergencyContactKanaName: null,
            //         emergencyContactRelationship: null,
            //         emergencyContactPhoneNumber: null,
            //       },
            //       {
            //         emergencyContactName: null,
            //         emergencyContactKanaName: null,
            //         emergencyContactRelationship: null,
            //         emergencyContactPhoneNumber: null,
            //       },
            //     ],
            //     modified: "2022-05-06 09:00:00",
            //   },
            // };

            this.modified = apiData.contentsInfo.modified;

            // 緊急連絡先リストの成形
            this.setEmergencyContactList(apiData.contentsInfo.emergencyContactList);

            const targetItem = apiData.contentsInfo.displayDistrictInfo;

            // ------- データ整形 ---------
            const labels = {
              usagePlan: '$vuetify.FECU42緊急連絡先設定画面.対象地区詳細表示領域.利用プラン',
              customerNumber: '$vuetify.FECU42緊急連絡先設定画面.対象地区詳細表示領域.お客様番号',
              securityDestinationName:
                '$vuetify.FECU42緊急連絡先設定画面.対象地区詳細表示領域.警備先名',
              districtSplitNumber:
                '$vuetify.FECU42緊急連絡先設定画面.対象地区詳細表示領域.地区番号',
              districtSplitName: '$vuetify.FECU42緊急連絡先設定画面.対象地区詳細表示領域.地区名',
              displayDistrictNickname: '',
            };
            const targetKeys = [
              'usagePlan',
              'customerNumber',
              'securityDestinationName',
              'districtSplitNumber',
              'districtSplitName',
              'displayDistrictNickname',
            ];

            const planTitles = {
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.ONLINE_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.オンライン監視プラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN]:
                '$vuetify.コード.利用プランID.依頼かけつけプラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN_NO_DEVICE]:
                '$vuetify.コード.利用プランID.依頼かけつけプラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.セルフ監視プラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN_NO_DEVICE]:
                '$vuetify.コード.利用プランID.セルフ監視プラン',
            };

            // ListPanelコンポーネント用に整形
            Object.keys(targetItem).map((key, index) => {
              if (targetKeys.includes(key)) {
                let text = targetItem[key];
                if (key === 'usagePlan') {
                  text = planTitles[targetItem[key]];
                }
                if (key === 'displayDistrictNickname') {
                  return;
                }
                if (key === 'districtSplitNumber') {
                  if (targetItem[key] === '    ') {
                    text = '$vuetify.FECU42緊急連絡先設定画面.メイン地区';
                  }
                  if (targetItem[key] === '') {
                    return;
                  }
                }
                this.result = [
                  ...this.result,
                  {
                    id: index,
                    title: labels[key],
                    text: text,
                    // isVuetifyKey: text.includes("$"),
                  },
                ];
              }
            });

            this.$emit('get-panel-data', {
              displayItems: this.result,
              title: {
                place: `${apiData.contentsInfo.displayDistrictInfo.displayDistrictNickname}`,
                type: '$vuetify.FECU27カメラ設定画面.対象地区',
                typeIsBefore: true,
              },
            });
          },
          (error) => {
            if (error.message.includes('400')) {
              this.$errorDialog(
                '$vuetify.メッセージ一覧.FECU42緊急連絡先設定画面.E0014',
                false,
                true
              );
            } else if (error.message.includes('403')) {
              this.$router.replace('/top');
            } else if (error.message.includes('500')) {
              this.$errorDialog(
                '$vuetify.メッセージ一覧.FECU42緊急連絡先設定画面.E0014',
                false,
                false,
                '/sorry'
              );
            } else {
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
      return apiData;
    },
    // APP_CU4202 緊急連絡先情報取得(カメラ)
    /**
     * 緊急連絡先情報(カメラ)取得API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストパラメータ
     * @param {*} method メソッドパラメータ
     * @returns apiData レスポンス
     */
    APP_CU4202: async function (param, queries, method) {
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          () => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     cameraInfo: {
            //       usagePlan: 0,
            //       customerNumber: "51-1234567",
            //       securityDestinationName: "警備先1",
            //       districtSplitNumber: "0001",
            //       districtSplitName: "地区名1",
            //       displayDistrictNickname: "自宅",
            //       cameraNickName: "リビングカメラ",
            //       deviceID: "1111",
            //     },
            //     emergencyContactList: [
            //       {
            //         emergencyContactName: "山田太郎",
            //         emergencyContactKanaName: "ヤマダタロウ",
            //         emergencyContactRelationship: "本人",
            //         emergencyContactPhoneNumber: "050-1234-1231",
            //       },
            //       {
            //         emergencyContactName: "山田田中",
            //         emergencyContactKanaName: "ヤマダタナカ",
            //         emergencyContactRelationship: "配偶者",
            //         emergencyContactPhoneNumber: "050-1192-5678",
            //       },
            //       {
            //         emergencyContactName: "山田花子",
            //         emergencyContactKanaName: "ヤマダハナコ",
            //         emergencyContactRelationship: "祖母",
            //         emergencyContactPhoneNumber: "050-1234-5678",
            //       },
            //       {
            //         emergencyContactName: null,
            //         emergencyContactKanaName: null,
            //         emergencyContactRelationship: null,
            //         emergencyContactPhoneNumber: null,
            //       },
            //       {
            //         emergencyContactName: null,
            //         emergencyContactKanaName: null,
            //         emergencyContactRelationship: null,
            //         emergencyContactPhoneNumber: null,
            //       },
            //     ],
            //     modified: "2022-05-06 09:00:00",
            //   },
            // };

            this.modified = apiData.contentsInfo.modified;

            // 緊急連絡先リストの成形
            this.setEmergencyContactList(apiData.contentsInfo.emergencyContactList);

            const targetItem = apiData.contentsInfo.cameraInfo;

            const labels = {
              usagePlan: '$vuetify.FECU42緊急連絡先設定画面.カメラ詳細表示領域.利用プラン',
              customerNumber: '$vuetify.FECU42緊急連絡先設定画面.カメラ詳細表示領域.お客様番号',
              securityDestinationName:
                '$vuetify.FECU42緊急連絡先設定画面.カメラ詳細表示領域.警備先名',
              districtSplitNumber: '$vuetify.FECU42緊急連絡先設定画面.カメラ詳細表示領域.地区番号',
              districtSplitName: '$vuetify.FECU42緊急連絡先設定画面.カメラ詳細表示領域.地区名',
              displayDistrictNickname:
                '$vuetify.FECU42緊急連絡先設定画面.カメラ詳細表示領域.ニックネーム地区表示',
              deviceID: '$vuetify.FECU42緊急連絡先設定画面.カメラ詳細表示領域.デバイスID',
            };

            const targetKeys = [
              'usagePlan',
              'customerNumber',
              'securityDestinationName',
              'districtSplitNumber',
              'districtSplitName',
              'displayDistrictNickname',
              'deviceID',
            ];

            const planTitles = {
              [CONSTANTS.CAMERA_USAGE_PLAN.ONLINE_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.オンライン監視プラン',
              [CONSTANTS.CAMERA_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN]:
                '$vuetify.コード.利用プランID.カメラ依頼かけつけプラン',
              [CONSTANTS.CAMERA_USAGE_PLAN.SELF_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.カメラセルフ監視プラン',
            };
            // ListPanelコンポーネント用に整形
            Object.keys(targetItem).map((key) => {
              if (targetKeys.includes(key)) {
                let text = targetItem[key];
                if (key === 'usagePlan') {
                  text = planTitles[targetItem[key]];
                }
                if (key === 'districtSplitNumber') {
                  if (targetItem[key] === '    ') {
                    text = '$vuetify.FECU42緊急連絡先設定画面.メイン地区';
                  }
                  if (targetItem[key] === '') {
                    return;
                  }
                }
                this.result = [
                  ...this.result,
                  {
                    title: labels[key],
                    text: text,
                    // isVuetifyKey: text.includes("$"),
                  },
                ];
              }
            });

            this.$emit('get-panel-data', {
              displayItems: this.result,
              title: {
                place: `${apiData.contentsInfo.cameraInfo.cameraNickName}`,
                type: '$vuetify.FECU27カメラ設定画面.カメラ',
                typeIsBefore: true,
              },
            });
          },
          (error) => {
            if (error.message.includes('400')) {
              this.$errorDialog(
                '$vuetify.メッセージ一覧.FECU42緊急連絡先設定画面.E0014',
                false,
                true
              );
            } else if (error.message.includes('403')) {
              this.$router.replace('/top');
            } else if (error.message.includes('500')) {
              this.$errorDialog(
                '$vuetify.メッセージ一覧.FECU42緊急連絡先設定画面.E0014',
                false,
                false,
                '/sorry'
              );
            } else {
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * 緊急連絡先情報(対象地区)更新API実行処理
     * @param {*} processType 処理区分
     */
    APP_CU4203: function (processType) {
      this.$_setLoading(true);

      let param = '/api/emergencyContact/updateContactInfoDisplayDistrict';
      let method = 'post';

      const emptyContact = {
        emergencyContactName: '',
        emergencyContactKanaName: '',
        emergencyContactRelationship: '',
        emergencyContactPhoneNumber: '',
      };

      const emergencyContactInfo = this.contactsCopy.map((contact) => {
        const shapedContact = {
          emergencyContactName: contact.name,
          emergencyContactKanaName: contact.nameKana,
          emergencyContactRelationship: contact.relationship,
          emergencyContactPhoneNumber: contact.phoneNumber,
        };
        return shapedContact;
      });

      // リクエストで送るemergencyContactInfoのサイズは必ず5,登録されている数が5未満の場合はからのcontactで埋める
      for (; emergencyContactInfo.length < CONSTANTS.REGISTRATION_LIMIT.EMERGENCY_CONTACT; ) {
        emergencyContactInfo.push(emptyContact);
      }

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: this.$store.state.customerNumber,
        districtSplitNumber: this.$store.state.districtSplitNumber,
        emergencyContactInfo: emergencyContactInfo,
        modified: this.modified,
      };

      this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          () => {
            this.success(processType);
          },
          (error) => {
            this.callErrorDialog(error, processType);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
    },
    /**
     * 更新処理完了時
     * @param {*} processType 処理区分
     */
    async success(processType) {
      await this.successDialog(processType);
    },
    /**
     * 緊急連絡先情報(カメラ)更新API実行処理
     * @param {*} processType 処理区分
     */
    APP_CU4204: function (processType) {
      this.$_setLoading(true);

      let param = '/api/emergencyContact/updateContactInfoCamera';
      let method = 'post';

      const emergencyContactInfo = this.contactsCopy.map((contact) => {
        const shapedContact = {
          emergencyContactName: contact.name,
          emergencyContactKanaName: contact.nameKana,
          emergencyContactRelationship: contact.relationship,
          emergencyContactPhoneNumber: contact.phoneNumber,
        };
        return shapedContact;
      });

      const emptyContact = {
        emergencyContactName: '',
        emergencyContactKanaName: '',
        emergencyContactRelationship: '',
        emergencyContactPhoneNumber: '',
      };

      // リクエストで送るemergencyContactInfoのサイズは必ず5,登録されている数が5未満の場合はからのcontactで埋める
      for (; emergencyContactInfo.length < CONSTANTS.REGISTRATION_LIMIT.EMERGENCY_CONTACT; ) {
        emergencyContactInfo.push(emptyContact);
      }

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        deviceID: this.$store.state.deviceID,
        emergencyContactInfo: emergencyContactInfo,
        modified: this.modified,
      };

      this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          () => {
            this.success(processType);
          },
          (error) => {
            this.callErrorDialog(error, processType);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
    },
    /**
     * 緊急連絡先リストの成形処理
     * @param {*} emergencyContactList 緊急連絡先リスト
     */
    setEmergencyContactList(emergencyContactList) {
      emergencyContactList = emergencyContactList.filter((contact) =>
        this.isExistEmergencyContact(contact)
      );
      if (emergencyContactList.length === 0) {
        // 中間IFDBSV緊急連絡先情報未登録
        this.$errorDialog('$vuetify.メッセージ一覧.FECU42緊急連絡先設定画面.E0015', false, true);
      } else {
        // 1件以上ある場合、緊急連絡先1～5順序通りに表示する
        emergencyContactList.forEach((emergencyContact, idx) => {
          this.contacts.push({
            id: idx + 1,
            name: emergencyContact.emergencyContactName,
            nameKana: emergencyContact.emergencyContactKanaName,
            relationship: emergencyContact.emergencyContactRelationship,
            phoneNumber: emergencyContact.emergencyContactPhoneNumber,
          });
          this.contactsCopy.push({
            id: idx + 1,
            name: emergencyContact.emergencyContactName,
            nameKana: emergencyContact.emergencyContactKanaName,
            relationship: emergencyContact.emergencyContactRelationship,
            phoneNumber: emergencyContact.emergencyContactPhoneNumber,
          });
        });
      }
      this.contacts = this.contacts.filter((contact) => this.isExistContact(contact));
      this.contactsCopy = this.contactsCopy.filter((contact) => this.isExistContact(contact));
    },
    /**
     * 完了ダイアログ表示
     * @param {*} processType 処理区分
     */
    successDialog(processType) {
      let message = '';
      switch (processType) {
        case CONSTANTS.PROCESS_TYPE.ADD:
        case CONSTANTS.PROCESS_TYPE.CHANGE:
          message = '$vuetify.メッセージ一覧.FECU42緊急連絡先設定画面.C0004';
          break;
        case CONSTANTS.PROCESS_TYPE.DELETE:
          message = '$vuetify.メッセージ一覧.FECU42緊急連絡先設定画面.C0005';
          break;
        case CONSTANTS.PROCESS_TYPE.SORT:
          message = '$vuetify.メッセージ一覧.FECU42緊急連絡先設定画面.C0006';
          break;
        default:
          break;
      }
      this.$informationDialog(message, true);
    },
    /**
     * エラーダイアログ表示
     * @param {*} error エラー
     * @param {*} processType 処理区分
     */
    callErrorDialog(error, processType) {
      let message = '';
      if (error.message.includes('400')) {
        switch (processType) {
          case CONSTANTS.PROCESS_TYPE.ADD:
            message = '$vuetify.メッセージ一覧.FECU42緊急連絡先設定画面.E0012';
            break;
          case CONSTANTS.PROCESS_TYPE.CHANGE:
            message = '$vuetify.メッセージ一覧.FECU42緊急連絡先設定画面.E0011';
            break;
          case CONSTANTS.PROCESS_TYPE.DELETE:
            message = '$vuetify.メッセージ一覧.FECU42緊急連絡先設定画面.E0013';
            break;
          case CONSTANTS.PROCESS_TYPE.SORT:
            message = '$vuetify.メッセージ一覧.FECU42緊急連絡先設定画面.E0016';
            break;
          default:
            break;
        }
        this.$errorDialog(message);
      } else {
        this.$_abnormality(error.response.status);
      }
    },
    /**
     * 確認ダイアログ表示
     * @param {*} processType 処理区分
     * @param {*} newContact 緊急連絡先(変更後)
     */
    async callSaveAgreementDialogDialog(processType, newContact) {
      // 連絡先のコピーを作成
      const copyContacts = [...this.contactsCopy];

      const result = await this.$agreementDialog(
        '$vuetify.agreementDialog.確認',
        '$vuetify.メッセージ一覧.FECU42緊急連絡先設定画面.C0002',
        '$vuetify.agreementDialog.いいえボタン',
        '$vuetify.agreementDialog.はいボタン'
      );
      if (result) {
        if (processType === CONSTANTS.PROCESS_TYPE.ADD) {
          this.contactsCopy = [...this.contactsCopy, newContact];
        } else {
          const index = this.contactsCopy.findIndex((contact) => contact.id == newContact.id);
          this.contactsCopy[index] = newContact;
        }
        // 遷移元の画面によって、APP_CU4203かAPP_CU4204のどちらかを実行
        if (this.$store.state.currentDisplayType === CONSTANTS.DISPLAY_TYPE.HOME_SECURITY) {
          this.APP_CU4203(processType, newContact);
        } else {
          this.APP_CU4204(processType, newContact);
        }
      } else {
        // いいえボタンを押した場合、緊急連絡先を元々のものに変更
        this.contacts = [...copyContacts];
        this.$refs.editContactModal[this.editContactModalIndex].closeDialog();
      }
    },
    /**
     * バリデーション処理
     */
    validate() {
      if (!this.firstContact.name) {
        this.error.firstContact.hasNameError = true;
      } else {
        this.error.firstContact.hasNameError = false;
      }

      if (!this.firstContact.nameKana) {
        this.error.firstContact.hasNameKanaError = true;
      } else {
        this.error.firstContact.hasNameKanaError = false;
      }

      if (!this.firstContact.relationship) {
        this.error.firstContact.hasRelationshipError = true;
      } else {
        this.error.firstContact.hasRelationshipError = false;
      }

      if (!this.firstContact.phoneNumber) {
        this.error.firstContact.hasPhoneNumberError = true;
      } else {
        this.error.firstContact.hasPhoneNumberError = false;
      }

      this.$refs.form.validate();
    },
    /**
     * 並べ替えボタン押下時処理
     */
    startSortContact() {
      this.sortFlag = true;
      this.$emit('set-is-editing', true);
    },
    /**
     * 適用ボタン押下時処理
     */
    completeSortContact() {
      if (this.$store.state.currentDisplayType === CONSTANTS.DISPLAY_TYPE.HOME_SECURITY) {
        this.APP_CU4203(CONSTANTS.PROCESS_TYPE.SORT);
      } else {
        this.APP_CU4204(CONSTANTS.PROCESS_TYPE.SORT);
      }
      this.$emit('set-is-editing', false);
    },
    /**
     * 並べ替え終了時処理
     * @param {*} event イベント
     */
    onEnd(event) {
      // https://github.com/SortableJS/Sortable#event-object-demo
      let copyContact = {};
      const copyContacts = this.contactsCopy.map((obj) => {
        return obj;
      });

      switch (Math.sign(event.oldIndex - event.newIndex)) {
        case -1:
          // 前から後ろに入れ替え
          Object.assign(copyContact, this.contactsCopy[event.oldIndex]);
          copyContacts.splice(event.oldIndex, 1);
          copyContacts.splice(event.newIndex, 0, copyContact);
          break;
        case 1:
          // 後ろから前に入れ替え
          Object.assign(copyContact, this.contactsCopy[event.oldIndex]);
          copyContacts.splice(event.oldIndex, 1);
          copyContacts.splice(event.newIndex, 0, copyContact);
          break;
        default:
          break;
      }
      this.contactsCopy = copyContacts;
    },
    /**
     * 追加ボタン押下時処理
     * @param {*} contact 緊急連絡先
     */
    addContact(contact) {
      contact.id = this.contacts.length + 1;
      this.callSaveAgreementDialogDialog(CONSTANTS.PROCESS_TYPE.ADD, contact);
    },
    /**
     * 変更ボタン押下時処理
     * @param {*} newContact 緊急連絡先(変更後)
     */
    editContact(newContact) {
      this.callSaveAgreementDialogDialog(CONSTANTS.PROCESS_TYPE.CHANGE, newContact);
    },
    /**
     * 削除ボタン押下時処理
     * @param {*} id 対象ID
     */
    deleteContact(id) {
      this.contactsCopy = this.contacts.filter((contact) => contact.id !== id);
      if (this.$store.state.currentDisplayType === CONSTANTS.DISPLAY_TYPE.HOME_SECURITY) {
        this.APP_CU4203(CONSTANTS.PROCESS_TYPE.DELETE);
      } else {
        this.APP_CU4204(CONSTANTS.PROCESS_TYPE.DELETE);
      }
    },
    getModifiedDate() {
      const now = new Date();
      const modified = new Intl.DateTimeFormat('ja-jp', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      }).format(now);

      return modified;
    },
    /**
     * 空のデータかどうかチェック
     * @param {*} contact 緊急連絡先
     * @returns {boolean}
     */
    isExistContact(contact) {
      if (
        (contact.name === '' || contact.name === null) &&
        (contact.nameKana === '' || contact.nameKana === null) &&
        (contact.relationship === '' || contact.relationship === null) &&
        (contact.phoneNumber === '' || contact.phoneNumber === null)
      ) {
        return false;
      } else {
        return true;
      }
    },
    /**
     * 空のデータかどうかチェック
     * @param {*} contact
     * @returns {boolean}
     */
    isExistEmergencyContact(contact) {
      if (
        (contact.emergencyContactName === '' || contact.emergencyContactName === null) &&
        (contact.emergencyContactKanaName === '' || contact.emergencyContactKanaName === null) &&
        (contact.emergencyContactRelationship === '' ||
          contact.emergencyContactRelationship === null) &&
        (contact.emergencyContactPhoneNumber === '' || contact.emergencyContactPhoneNumber === null)
      ) {
        return false;
      } else {
        return true;
      }
    },
    /**
     * widthの調整
     * @param {*} width 幅
     */
    changeItemLabelWidth(width) {
      this.width = width;
    },
    /**
     * 英語表記時の序数詞の取得
     * @param {Number} index
     * @returns
     */
    getOrderNumber(index) {
      if (this.$vuetify.lang.current !== 'en') return index;

      let order = '';
      switch (index) {
        case 1:
          order = '1st';
          break;
        case 2:
          order = '2nd';
          break;
        case 3:
          order = '3rd';
          break;
        default:
          order = index + 'th';
          break;
      }
      return order;
    },
  },
  beforMount() {
    this.$_setLoading(true);
  },
};
